module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1500.ca03969c.svg";